import { Link } from "react-router-dom";
import urlFor from "./ImgBuilder";

export const Richtext = {
    types: {
        image: ({ value }) => {
            return (
                <div className="relative w-full">
                    {/* Change the max Height and other image styling for different results */}
                    {/* Choose the image of suitable size */}
                    <img src={urlFor(value).url()} alt={value.alt} className="max-h-56 object-cover w-full" />
                </div>
            );
        },

    },
    list: {
        bullet: ({ children }) => (
            <ul className="list-disc space-y-5 text-gray-300">{children}</ul>
        ),
        number: ({ children }) => (
            <ol className="list-decimal px-2 text-gray-300">{children}</ol>
        ),
    },
    block: {
        h1: ({ children }) => (
            <h1 className="text-5xl py-10 font-bold text-gray-100">{children}</h1>
        ),
        h2: ({ children }) => (
            <h2 className="text-4xl py-10 font-bold text-gray-200">{children}</h2>
        ),
        h3: ({ children }) => (
            <h3 className="text-3xl py-10 font-bold text-gray-300">{children}</h3>
        ),
        h4: ({ children }) => (
            <h4 className="text-2xl py-10 font-bold text-gray-400">{children}</h4>
        ),
        blockquote: ({ children }) => (
            <blockquote className="py-8 text-gray-700 bg-white rounded">{children}</blockquote>
        ),
        normal: ({ children }) => (
            <p className="text-gray-300">{children}</p>
        )
    },
    marks: {
        link: ({ children, value }) => {
            const rel = !value.href.startsWith("/")
                ? "noreferrer noopener" : undefined
            return (
                <Link to={value.href} rel={rel} target="_blank" className="underline decoration-blue-400 hover:decoration-black">
                    {children}
                </Link>
            )
        }
    }
}